import PageStyle from "@/styles/components/share-cv/_index.module.scss";
import AutomationStyle from "@/styles/components/automation-popup/_index.module.scss";
import AddNewModal from "@/styles/components/add-new-stage/_index.module.scss";
import Tooltip from "react-simple-tooltip";
import Phone from "public/icons/call2.svg";
import Tech from "public/icons/technical.svg";
import Video from "public/icons/video.svg";
import Face from "public/icons/user.svg";
import VideoQA from "public/icons/videoqa.svg";
import ButtonStyle from "@/styles/components/button/_index.module.scss";
import Autosuggest from "react-autosuggest";
import { Loading } from "@/components/loading";
import {
  AutocompleteError,
  Button,
  Field,
  FieldArray,
  InputError,
  InputText,
  Form,
  Formik,
  FormikControl,
  useState,
  addNewStageValidation,
  ADD_NEW_STAGE,
  INTERVIEW_TYPES,
  AddNewStageAction,
  Image,
  CustomAutocompleteError,
  JOB_STAGES,
} from "@/imports-files/components/add-new-stage";
import { FormModalStyle, Close } from "@/imports-files/components/review-email";
import {
  onSuggestionsFetchRequested,
  renderInputComponent,
  renderSuggestion,
  shouldRenderSuggestions,
  handleKeyDown,
  onAutomationChange,
  handleDelete,
  clearSWRCache,
  useSWR,
  useEffect,
  useRef,
  useTranslation
} from "@/imports-files/pages/clients/jobs/candidate-profile-job";
import Modal from "./common-modal/modal";

export function AddNewStage({ router, setBtnPopup, jobData, setJobData }) {
  const {t} = useTranslation()
  clearSWRCache("job_stage_info");
  const [users, setUsers] = useState([]);
  const [stageEmail, setStageEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [disabledSaveButton, setDisabledSaveButton] = useState(false);
  const addNewStageAction = new AddNewStageAction();
  const [interviewTypes, setinterviewTypes] = useState([]);
  const [stages, setStages] = useState([]);
  const [stagePositions, setStagePositions] = useState([]);
  const [stageType, setstageType] = useState([]);
  const [initialValues, setInitialValues] = useState(ADD_NEW_STAGE);
  const { data, error } = useSWR("job_stage_info", () => {
    return addNewStageAction.getJobInfo(jobData.id);
  });
  const selectDropdownRef = useRef(null);
  const [isScreening, setIsScreeing] = useState(false);
  useEffect(() => {
    if (data) {
      setStagePositions(data.stage_positions);
      setstageType(data.stage_type);
      setinterviewTypes(data.interview_types);
      initialValues.member_emails = [];
      initialValues.member_initials = [];
      setInitialValues(initialValues);
    }
  }, [data]);

  function interviewSwitchButton(type) {
    switch (type) {
      case INTERVIEW_TYPES.PHONE:
        return <Phone />;
      case INTERVIEW_TYPES.TECHTEST:
        return <Tech className="techIcon" />;
      case INTERVIEW_TYPES.VIDEO:
        return <Video />;
      case INTERVIEW_TYPES.FACE2FACE:
        return <Face className="faceIcon" />;
      case INTERVIEW_TYPES.VIDEOQA:
        return <VideoQA  className="videoQAIcon"/>;
      default:
        return "";
    }
  }
  return (
    <>
      <Modal
        type="form"
        heading={t('modal:add_new_stage')}
        closeModal={() => setBtnPopup(false)}
        largeWidth
        content={
          <Formik
            initialValues={initialValues}
            validationSchema={addNewStageValidation(isScreening)}
            onSubmit={async (values, actions) => {
              setDisabledSaveButton(true);
              let errors = await addNewStageAction.submitForm(
                values,
                setBtnPopup,
                jobData,
                setJobData,
                setIsLoading
              );
              actions.setErrors(errors);
              setDisabledSaveButton(false);
            }}
          >
            {(formik) => (
              <Form>
                <div className={`${AddNewModal.AddNewStage} AutomationPopup AddInterview`}>
                  <div className={FormModalStyle.Modal__Container__ContentSection__Block}>
                    <div className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol}`}>
                      <label className={`${PageStyle.Form__FloatingLabel}`} style={InputText(formik,`job_stage_label_attributes.label`)}>
                        <span className={`red-color`}>*</span>&nbsp;{t('modal:input:stage_name')}
                      </label>
                      <FormikControl
                        className={`${PageStyle.Form__Input} ${AddNewModal.AddNewStage__w100}`}
                        control="input"
                        type="text"
                        autocomplete="off"
                        placeholder={t('placeholder:add_stage')}
                        formik={formik}
                        maxLength={255}
                        name={`job_stage_label_attributes.label`}
                        value={formik.values.job_stage_label_attributes.label}
                        style={InputError(
                          formik,
                          `job_stage_label_attributes.label`
                        )}
                        custom_class={`FieldError`}
                      ></FormikControl>
                    </div>

                    <div className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol}`}>
                      <label className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}>
                        <span className={`red-color`}>{isScreening ? "" : "*"}</span>&nbsp;{t('modal:automation:interview:type')}
                      </label>
                      <div
                        className={
                          FormModalStyle.Modal__Container__ContentSection__Block__IconContainer
                        }
                      >
                        {interviewTypes.map((x, interviewIndex) => {
                          return (
                            <div
                              className={
                                FormModalStyle.Modal__Container__ContentSection__Block__IconContainer__Icons
                              }
                              key={`interview_type_${interviewIndex}`}
                            >
                              <Tooltip
                                className="SimpleTooltip"
                                background={"#00325A"}
                                radius={50}
                                padding={11}
                                placement="top"
                                fontSize="12px"
                                content={x.display_name}
                                key={x.name}
                              >
                                <p
                                  className={`${PageStyle.Interview__IconsType} ${AddNewModal.Interview__IconsType}`}
                                >
                                  <input
                                    type="radio"
                                    name="interview_type_id"
                                    id={`icon${interviewIndex}`}
                                    defaultChecked={
                                      formik.values.interview_type_id == x.id
                                    }
                                    checked={
                                      formik.values.interview_type_id == x.id
                                    }
                                    onClick={() => {
                                      if (
                                        formik.values.interview_type_id != "" &&
                                        isScreening &&
                                        formik.values.interview_type_id == x.id
                                      ) {
                                        formik.setFieldValue(
                                          "interview_type_id",
                                          ""
                                        );
                                      } else {
                                        formik.setFieldValue(
                                          "interview_type_id",
                                          x.id
                                        );
                                      }
                                    }}
                                  />
                                  <label
                                    htmlFor={`icon${interviewIndex}`}
                                    className={`labelcolor`}
                                  >
                                    {interviewSwitchButton(x.name)}
                                  </label>
                                </p>
                              </Tooltip>
                            </div>
                          );
                        })}
                      </div>
                      <AutocompleteError
                        name={"interview_type_id"}
                        errorClass={PageStyle.Form__Error}
                        formik={formik}
                        style={InputError(formik, "interview_type_id")}
                        custom_class={`FieldError`}
                      />
                    </div>
                  </div>

                  <div
                    className={
                      FormModalStyle.Modal__Container__ContentSection__BlockContainer
                    }
                    style={{ gridTemplateColumns: "auto auto" }}
                  >

                    <div className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol} mt0`}>
                      <label className={`${PageStyle.Form__FloatingLabel}`} style={InputText(formik, `stage_id`)}>
                        <span className={`red-color`}>*</span>&nbsp;{t('modal:input:stage_type')}
                      </label>
                      <div className={`w100`}>
                        <FormikControl
                          className={`${PageStyle.Form__CustomSelect}`}
                          control="select"
                          formik={formik}
                          placeholder={t('placeholder:select:stage_type')}
                          options={stageType}
                          onChange={(option) => {
                            formik.setFieldValue(`stage_id`, option.value);
                            let options =
                              stagePositions[option.key.toLowerCase()];
                            setStages([...options]);
                            selectDropdownRef.current.select.clearValue();
                            setIsScreeing(
                              option.value.toString() ==
                                stageType
                                  .find((x) => x.label == JOB_STAGES.SCREENING)
                                  ?.value?.toString()
                            );
                            formik.setFieldValue(`after_stage_id`, "");
                          }}
                          default={formik.values.select_stage_type}
                          name={`stage_id`}
                          style={InputError(formik, `stage_id`)}
                          custom_class={`FieldError`}
                        />
                      </div>
                    </div>
                    <div
                      className={
                        `${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol} mt0`
                      }
                    >
                      <label className={`${PageStyle.Form__FloatingLabel}`} style={InputText(formik, `after_stage_id`)}>
                        <span className={`red-color`}>*</span>&nbsp;{t('modal:input:position')}
                      </label>
                      <FormikControl
                        className={`${PageStyle.Form__CustomSelect}`}
                        control="select"
                        formik={formik}
                        placeholder={t('placeholder:select:position')}
                        options={stages}
                        onChange={(option) => {
                          formik.setFieldValue(`after_stage_id`, option?.value);
                        }}
                        default={formik.values.after_stage_id}
                        name={`after_stage_id`}
                        style={InputError(formik, `after_stage_id`)}
                        custom_class={`FieldError`}
                        reference={selectDropdownRef}
                      />
                    </div>
                  </div>

                  <div>
                    <div
                      className={`${PageStyle.SetupPopup__SubmitSectionAutomation} ${AddNewModal.SetupPopup__Content__Submit}`}
                    >
                      <Button
                        buttonstyle={`${ButtonStyle.primarybtn}`}
                        type="submit"
                        disabled={disabledSaveButton}
                      >
                      {t('button:save')}
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        }
      />
      {isLoading && <Loading />}
    </>
  );
}
